<script setup>
import { useAuthStore } from "@/stores";
import { computed, onBeforeMount } from "vue";
import DynamicLayoutPage from "./DynamicLayoutPage.vue";
import AuthenticatedPage from "./AuthenticatedPage.vue";

const authStore = useAuthStore();
const selectedLayout = computed(() => authStore.selectedThemeLayout);

// const { loadingUser } = storeToRefs(authStore)

const display = computed(() => {
  if (selectedLayout.value === "layout_assignments_dynamic") {
    return DynamicLayoutPage;
  }
  return AuthenticatedPage;
});

onBeforeMount(() => {
})
</script>

<template>
  <component :is="display">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<style lang="scss" scoped></style>
